import { theme } from 'antd';
import React from 'react';

import {
  CheckCircleTwoTone,
  CloseCircleTwoTone,
  ExclamationCircleTwoTone,
} from '@ant-design/icons';

export interface TipIconProps {
  type?: 'success' | 'error';
  style?: React.CSSProperties;
}

const { useToken } = theme;

const TipIcon = React.memo(({ type, style }: TipIconProps) => {
  const { token } = useToken();

  switch (type) {
    case 'error':
      return <CloseCircleTwoTone twoToneColor={token.colorError} style={style} />;
    case 'success':
      return <CheckCircleTwoTone twoToneColor={token.colorSuccess} style={style} />;
    default:
      return <ExclamationCircleTwoTone style={style} />;
  }
});

export default TipIcon;
